"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseVAST = void 0;
const fast_xml_parser_1 = require("fast-xml-parser");
const xmlParser = new fast_xml_parser_1.XMLParser({
    ignoreAttributes: false,
    allowBooleanAttributes: true,
    parseAttributeValue: true,
    alwaysCreateTextNode: true,
});
function parseImpression(impression) {
    if (Array.isArray(impression)) {
        return impression.map((value) => value["#text"]);
    }
    else if (impression === null || impression === void 0 ? void 0 : impression["#text"]) {
        return [impression["#text"]];
    }
    return [];
}
function getTrackingMap(events) {
    const trackingMap = {};
    events.forEach((tracking) => {
        const evtArray = trackingMap[tracking["@_event"]];
        if (!evtArray) {
            trackingMap[tracking["@_event"]] = [tracking["#text"]];
        }
        else {
            evtArray.push(tracking["#text"]);
        }
    });
    return trackingMap;
}
function parseVAST(xml, idPrefix = "") {
    var _a;
    const ads = [];
    const json = xmlParser.parse(xml);
    if ((_a = json === null || json === void 0 ? void 0 : json.VAST) === null || _a === void 0 ? void 0 : _a.Ad) {
        const adVasts = Array.isArray(json.VAST.Ad)
            ? json.VAST.Ad
            : [json.VAST.Ad];
        adVasts.forEach((vastRepresentation, index) => {
            var _a, _b, _c;
            const InLine = vastRepresentation.InLine;
            const LinearAd = (_b = (_a = InLine === null || InLine === void 0 ? void 0 : InLine.Creatives) === null || _a === void 0 ? void 0 : _a.Creative) === null || _b === void 0 ? void 0 : _b.Linear;
            const Tracking = (_c = LinearAd === null || LinearAd === void 0 ? void 0 : LinearAd.TrackingEvents) === null || _c === void 0 ? void 0 : _c.Tracking;
            const impression = parseImpression(InLine === null || InLine === void 0 ? void 0 : InLine.Impression);
            const trackingMap = getTrackingMap(Tracking);
            const adId = vastRepresentation["@_id"] ||
                `title:${InLine === null || InLine === void 0 ? void 0 : InLine.AdTitle["#text"]},system:${InLine === null || InLine === void 0 ? void 0 : InLine.AdSystem["#text"]}`;
            const adDataRepresentation = {
                id: `${idPrefix}_${index}_${adId}`,
                system: InLine === null || InLine === void 0 ? void 0 : InLine.AdSystem["#text"],
                title: InLine === null || InLine === void 0 ? void 0 : InLine.AdTitle["#text"],
                duration: new Date(`1970-01-01T${LinearAd === null || LinearAd === void 0 ? void 0 : LinearAd.Duration["#text"]}.000Z`).getTime(),
                trackingEvents: Object.assign({ impression: impression || [] }, trackingMap),
            };
            ads.push(adDataRepresentation);
        });
    }
    return ads;
}
exports.parseVAST = parseVAST;
//# sourceMappingURL=vast.js.map